/*!
 *
 * Angle - Bootstrap Admin Template
 *
 * Version: 4.8.1
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import { ToastContainer } from "react-toastify";
// Vendor dependencies
import "./Vendor";
// Application Styles
import "./styles/bootstrap.scss";
import "./styles/app.scss";

const App = () => {
    // specify base href from env varible 'PUBLIC_URL'
    // use only if application isn't served from the root
    // for development it is forced to root only
    // global PUBLIC_URL

    const basename =
        // eslint-disable-next-line no-undef
        process.env.NODE_ENV === "development" ? "/" : process.env.REACT_APP_BASE_PATH || "/";

    return (
        <>
            <BrowserRouter basename={basename}>
                <Routes />
            </BrowserRouter>
            <ToastContainer />
        </>
    );
};

export default App;
